import http from "@/http/http"
import memoryStore from "@/util/memoryStore"
import { formatAreaFeatures, handleAreasResult } from "./helper"
export const getAllAreaPolygon = async () => {
  try {
    let url = "/v1/areas"
    const result = await http.get(url, {
      params: { has_polygon: true },
    })
    return handleAreasResult(result)
  } catch (error) {
    return { tree: [], map: {} }
  }
}

export const getAreaPolygon = async (code?: string) => {
  try {
    let url = "/v1/areas"
    if (!code) {
      url = window.location.origin + "/geo/100000.json"
    }
    const result = await http.get(url, {
      params: { code, has_polygon: true, need_part: true },
    })

    const { data = [] } = result
    if (!code) {
      return data
    }
    let features = []
    data.forEach(area => {
      features.push(formatAreaFeatures(area))
      if (area.sub_areas) {
        area.sub_areas.forEach(subArea => {
          features.push(formatAreaFeatures(subArea))
        })
      }
    })
    return {
      type: "FeatureCollection",
      features,
    }
  } catch (error) {}
}

export const getProviceCity = async () => {
  const key = `__province_city__`
  let d = memoryStore.getItem(key)
  if (d) return d

  try {
    const result = await http.get(`/v1/areas`)
    const data = result.data || []
    data.unshift({ name: "全国", code: 0 })
    memoryStore.setItem(key, data)
    return data
  } catch (error) {}
}
